module.exports = __webpack_public_path__ + "static/media/high-left-4.0c4da550.png";